module.exports = __webpack_public_path__ + "img/logo.46028c80.gif";